import * as React from 'react';
import StockSubmitSection from 'modules/StockSubmitSection';
import StockLandingAuthentication from 'components/StockLandingAuth';
import ExchangeWorkingCountdown from 'components/ExchangeWorkingCountdown';
import DisabledStockNotify from 'components/DisabledStockNotify';
import { useAuthenticationStatus } from 'shared/hooks/user';
import { useExchangeWorkingHours } from 'queries/ExchangeWorkingHours/hook';

interface Props {
  id: number;
  symbol: string;
  disabled?: boolean;
}

export const ActualForm: React.FC<Props> = ({ id, symbol, disabled }) => {
  const isAuthenticated = useAuthenticationStatus();
  const { refetch: refetchWorkingHours, from, to, isOnline } = useExchangeWorkingHours();
  if (!isAuthenticated) {
    return <StockLandingAuthentication symbol={symbol} />;
  }

  if (disabled) {
    return <DisabledStockNotify />;
  }

  if (!isOnline && from && to) {
    return (
      <ExchangeWorkingCountdown
        template="landing"
        from={from}
        to={to}
        onExceed={refetchWorkingHours}
      />
    );
  }

  return <StockSubmitSection id={id} form="stock-landing-lower-form" />;
};
